import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

const ACCOUNT_V3_PREFIX = '/api/v3/account';

@Injectable({ providedIn: 'root' })
export class MatchExclusionsBackend {
  v3 = {
    postAccountMatchExclusions: (
      groupId: string,
      update: { match_exclusions: { [key: string]: any }[] },
    ) =>
      this.http.post(
        `${ACCOUNT_V3_PREFIX}/groups/${groupId}/match_exclusions`,
        update,
      ),
    putAccountMatchExclusions: (
      groupId: string,
      update: { match_exclusions: { [key: string]: any }[] },
    ) =>
      this.http.put(
        `${ACCOUNT_V3_PREFIX}/groups/${groupId}/match_exclusions`,
        update,
      ),
    deleteAccountMatchExclusions: (groupId: string, matchExclusionId: string) =>
      this.http.delete(
        `${ACCOUNT_V3_PREFIX}/groups/${groupId}/match_exclusions/${matchExclusionId}`,
      ),
  };

  constructor(private http: HttpClient) {}
}
